var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-tv-devices-kaltura container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('app-search-box',{attrs:{"label":"Household ID","loading":_vm.loading},on:{"search":_vm.onSearch}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }